import React, { useLayoutEffect, useState } from "react";
import { Navbar } from "./Navbar";
import { useLocation } from "react-router-dom";

const VenueOwnerLayout = ({ children }) => {
  const { pathname } = useLocation();
  const [MainLayout, setMainLayout] = useState(true);
  useLayoutEffect(() => {
    if (pathname != "/home-venue-owner") {
      setMainLayout(true);
    } else {
      setMainLayout(false);
    }
  }, [pathname]);
  return (
    <React.Fragment>
      <>
        <div id="wrapper">
          {/* <div id="wrapperHeader">
            <Navbar />
          </div> */}
          <div id="wrapperMain" className={`row mx-0`}>
            <div
              fixed={true}
              className={`${
                MainLayout
                  ? "col-12 px-0"
                  : "col-md-6 col-lg-6 col-12 m-auto my-0 "
              } pb-1 px-0`}
            >
              <main className="container-fluid px-0">{children}</main>
            </div>
          </div>
        </div>
      </>
    </React.Fragment>
  );
};
export default VenueOwnerLayout;
